var _desc, _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Comment Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Church-themed comment/message icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25 L80 25 A10 10 0 0 1 90 35 L90 60 A10 10 0 0 1 80 70 L40 70 L25 80 L25 70 L20 70 A10 10 0 0 1 10 60 L10 35 A10 10 0 0 1 20 25 Z",
    fill: "#D4C4A0",
    stroke: "#C8B59B",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 40,
    x2: 75,
    y2: 40,
    stroke: "#9EC630",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 50,
    x2: 65,
    y2: 50,
    stroke: "#9EC630",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 60,
    x2: 55,
    y2: 60,
    stroke: "#9EC630",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.aa2b88f2ee41f6e5d85204679dd7067e.svg";
export { ForwardRef as ReactComponent };